import { authTypes } from './actions';
import { disabledSalonById, setActiveSalonById, setActiveSalonInfo } from '../../../utils/salonToken';

const initialState = {
  salons: [],
  isLogin: false,
  activeSalonId: false,
  isSwitchingSalon: false,
  signUpValues: {
    salonWorkTimes: {
      startMorning: null,
      endMorning: null,
      startEvening: null,
      endEvening: null,
    },
    activeStepId: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case authTypes.SIGN_IN.REQUEST:
      return {
        ...state,
      };
    case authTypes.SIGN_IN.FAILED:
      return {
        ...state,
      };
    case authTypes.FETCH_SALON.SUCCESS: {
      const fetchedSalons = action.payload.salons ?? action.payload;
      return {
        ...state,
        salons: Array.isArray(fetchedSalons) ? fetchedSalons : state.salons || [],
        activeSalonId: action.payload.activeSalonId ?? state.activeSalonId,
        isSwitchingSalon: false,
      };
    }
    case authTypes.FETCH_SALON.FAILED:
      return {
        ...state,
        isSwitchingSalon: false,
      };
    case authTypes.SIGN_IN.SUCCESS:
      return {
        ...state,
        isLogin: true,
        activeSalonId: action.payload.activeSalonId,
        salons: Array.isArray(action.payload.salons) ? action.payload.salons : state.salons || [],
        isSwitchingSalon: false,
      };
    case authTypes.SET_ACTIVE_SALON.REQUEST:
      return {
        ...state,
        isSwitchingSalon: true,
      };
    case authTypes.SET_ACTIVE_SALON.SUCCESS:
      setActiveSalonById(action.payload);
      return {
        ...state,
        activeSalonId: action.payload,
        isSwitchingSalon: true,
      };
    case authTypes.SET_ACTIVE_SALON.FAILED:
      return {
        ...state,
        isSwitchingSalon: false,
      };
      case authTypes.SET_ID_COSTUMER_STRIPE.SUCCESS: {
        const stripeCustomerId = action.payload.idCustomerStripe;
        const updatedSalons = (Array.isArray(state.salons) ? state.salons : []).map((salon) =>
          +state.activeSalonId === +salon.idsalone
            ? { ...salon, idCostumerStripe: stripeCustomerId }
            : salon,
        );
        const activeSalon = updatedSalons.find((salon) => +salon.idsalone === +state.activeSalonId);
        if (activeSalon && stripeCustomerId) {
          setActiveSalonInfo({ idsalone: activeSalon.idsalone, idCostumerStripe: stripeCustomerId });
        }
        return {
          ...state,
          salons: updatedSalons,
        };
      }
    case authTypes.EDIT_SALON_INFO.SUCCESS:
      return {
        ...state,
        salons: state.salons.map((salon) =>
          action.payload.idsalone === salon.idsalone ? { ...salon, ...action.payload } : salon,
        ),
      };
    case authTypes.RESET_HOME_STATS.SUCCESS:
      return {
        ...state,
        salons: state.salons.map((salon) => {
          const isTargetByPayload =
            action.payload?.idsalone !== undefined &&
            +action.payload.idsalone === +salon.idsalone;
          const isTargetByActiveSalon = +state.activeSalonId === +salon.idsalone;

          if (isTargetByPayload || isTargetByActiveSalon) {
            return { ...salon, ...action.payload };
          }
          return salon;
        }),
      };
    case authTypes.ACTIVE_PAYMENT.SUCCESS:
      return {
        ...state,
        salons: state.salons.map((salon) =>
          action.payload.idsalone === salon.idsalone ? { ...salon, ...action.payload } : salon,
        ),
      };
    case authTypes.DELETE_SALON.SUCCESS:
      disabledSalonById(action.payload);
      return {
        ...state,
        salons: state.salons.filter((salon) => action.payload !== salon.idsalone),
      };
    case authTypes.LOG_OUT.SUCCESS:
      return {
        ...state,
        isLogin: false,
        activeSalonId: false,
        salons: [],
        isSwitchingSalon: false,
      };
    case authTypes.GET_ACTIVE_SIGN_UP_STEP.SUCCESS:
      return {
        ...state,
        signUpValues: {
          ...state.signUpValues,
          activeStepId: action.payload,
        },
      };
    case authTypes.SET_SALON_WORK_TIMES.SUCCESS:
      return {
        ...state,
        signUpValues: {
          ...state.signUpValues,
          salonWorkTimes: {
            ...state.signUpValues.salonWorkTimes,
            ...action.payload,
          },
        },
      };
    case authTypes.GET_ACTIVE_SIGN_UP_STEP.CLEAR:
      return {
        ...state,
        signUpValues: {
          salonWorkTimes: {
            startMorning: null,
            endMorning: null,
            startEvening: null,
            endEvening: null,
          },
          activeStepId: false,
        },
      };
      case authTypes.CREATE_CUSTOMER.SUCCESS: {
        const customerId = action.payload.customer?.id;
        return {
          ...state,
          salons: state.salons.map((salon) =>
            +action.payload.idSalone === +salon.idsalone
              ? {
                  ...salon,
                  idCostumerStripe: customerId,
                  tel: action.payload.customer?.phone ?? salon.tel,
                }
              : salon,
          ),
        };
      }
    default:
      return { ...state };
  }
};
